export default __webpack_public_path__ + "static/06-cb3848223677312c95c47269bc93165b.jpg";